module.exports = __webpack_public_path__ + "img/WCA医药专项会员2025.716b0563.jpg";